<template>
  <!-- 线下考试报名 -->
  <div class="index-container">
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 在线考试
        <span>> 线下考试</span>
      </div>
      <div class="module-box">
        <div class="test-name">
          {{ title }}
          <span>线下</span>
        </div>
        <!-- <div class="test-detail">
          考试时间
          <span>{{total_time}}</span> 分钟
        </div>-->
      </div>
      <div class="sign-content">
        <div class="sign-list">
          <div class="list-title">考试人</div>
          <el-input v-model="name" placeholder="请输入考试人的名称"></el-input>
        </div>
        <div class="sign-list">
          <div class="list-title">联络邮箱</div>
          <el-input v-model="email" placeholder="请输入联络邮箱"></el-input>
        </div>
        <div class="sign-list">
          <div class="list-title">选择校区</div>
          <el-select class="c-list" v-model="area" placeholder="请选择校区">
            <el-option v-for="item in areaList" :key="item.uuid" :label="item.title" :value="item.uuid"></el-option>
          </el-select>
        </div>
        <div class="sign-list">
          <div class="list-title">报名考试时间</div>
          <el-date-picker v-model="examDate" type="date" placeholder="选择日期"></el-date-picker>
          <!-- <el-time-select
            placeholder="起始时间"
            v-model="startTime"
            :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '23:30'
              }"
          ></el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="endTime"
            :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '23:30',
                minTime: startTime
              }"
          ></el-time-select>-->
        </div>
        <div class="sign-list">
          <div class="list-title">上传附件</div>
          <!-- list-type="picture-card" -->
          <el-upload
            :limit="1"
            :action="uploadUrl"
            :on-remove="handleRemove"
            :on-success="successUpload"
            :on-preview="previewFile"
            :file-list="fileList"
          >
            <!-- <i class="el-icon-plus"></i> -->
            <el-button size="small" type="primary">点击上传</el-button>（最多上传一个文件）
          </el-upload>
        </div>
        <div class="sign-button" @click="sign">提交报名</div>
      </div>
    </div>
    <el-dialog class="form-box" :visible.sync="dialogVisible" width="600PX">
      <video
        oncontextmenu="return false;"
        autoplay
        class="dialog-img"
        v-if="urlType == 'mp4'"
        :src="imgUrl + previewUrl"
      ></video>
      <div v-else class="dialog-img" :style="{ backgroundImage: 'url( ' + imgUrl + previewUrl + ')' }"></div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api/api";
import { upload_url } from "../api/index";
import { imgUrl } from "../api/index";

export default {
  name: "testOffline",
  data() {
    return {
      imgUrl: imgUrl,
      name: "",
      email: "",
      areaList: [],
      area: "",
      fileList: [],
      uploadUrl: upload_url,
      examDate: "",
      startTime: "",
      endTime: "",
      thumb: "",
      title: "",
      total_time: "",
      dialogVisible: false,
      previewUrl: "",
      urlType: "",
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getSchoolList();
    const value = this.$route.query;
    console.log(value);
    if (value) {
      this.paper_uuid = value.id;
      this.title = value.title;
      this.total_time = value.total_time;
    }
  },
  methods: {
    deleteFile(index) {
      //   this.order[index].answer = [];
    },
    //   上传后预览
    previewFile(file) {
      console.log(file);
      let url = file.name.split(".");
      console.log(url);
      this.urlType = url[1];
      this.previewUrl = file.response.result;
      this.dialogVisible = true;
    },
    //   获取学校列表
    getSchoolList() {
      api.getSchoolList().then((res) => {
        console.log(res);
        if (res.result) {
          this.areaList = res.result.data;
        }
      });
    },
    sign() {
      const params = {
        paper_uuid: this.paper_uuid,
        school_uuid: this.area,
        thumb: this.thumb,
        exam_time: this.examDate,
        join_name: this.name,
        join_email: this.email,
      };
      if (!this.name) {
        this.$message.warning("请输入姓名！");
      } else if (!this.email) {
        this.$message.warning("请输入邮箱！");
      } else if (!this.area) {
        this.$message.warning("请选择校区！");
      } else if (!this.examDate) {
        this.$message.warning("请选择考试时间！");
      } else if (!this.thumb) {
        this.$message.warning("请上传附件！");
      } else {
        api.offlineSign(params).then((res) => {
          console.log(res);
          if (res && res.result) {
            this.name = "";
            this.area = "";
            this.thumb = "";
            this.fileList = [];
            this.examDate = "";
            this.email = "";
            this.$message.success("报名成功！");
          } else {
            this.$message.warning("报名失败！");
          }
        });
      }
    },
    // 移除
    handleRemove(file) {
      console.log(file);
      this.thumb = "";
    },
    // 上传成功
    successUpload(res, file, fileList) {
      console.log(res);
      if (res.result) {
        this.thumb = res.result;
        this.$message.success("上传成功！");
      } else {
        this.$message.warning("上传失败！");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 40px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.module-box {
  padding: 40px 42px 32px;
  margin-bottom: 30px;
  background-color: #ffffff;
  .test-name {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    font-size: 26px;
    color: #333333;
    font-weight: 600;
    span {
      padding: 2px 5px;
      margin-left: 8px;
      font-size: 14px;
      color: #ffffff;
      background-color: #ff7b1f;
      border-radius: 5px;
    }
  }
  .test-detail {
    font-size: 16px;
    color: #777777;
    span {
      color: #333333;
    }
  }
}
.sign-content {
  padding: 46px 52px 72px;
  background-color: #ffffff;
  .sign-list {
    display: flex;
    margin-bottom: 20px;
  }
  .list-title {
    width: 84px;
    margin-right: 14px;
    color: #666666;
    line-height: 36px;
    text-align: right;
  }
  .sign-button {
    width: 342px;
    margin: 84px auto 0;
    font-size: 20px;
    color: #ffffff;
    line-height: 64px;
    text-align: center;
    background: #f1a373;
    border-radius: 45px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  /deep/ {
    .el-input {
      width: 263px;
      margin-right: 10px;
    }
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
    .el-upload--picture-card {
      width: 90px;
      height: 84px;
      line-height: 84px;
      border-radius: 3px;
      border: 1px solid #dddddd;
    }
  }
}

.form-box {
  video {
    width: 100%;
    height: 100%;
    // object-fit: fill;
  }

  .dialog-img {
    width: 90%;
    height: 445px;
    margin: 0 auto 26px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/testOffline.vue